import { render, staticRenderFns } from "./deleteIcon.vue?vue&type=template&id=6b7977d6&scoped=true&"
import script from "./deleteIcon.vue?vue&type=script&lang=js&"
export * from "./deleteIcon.vue?vue&type=script&lang=js&"
import style0 from "./deleteIcon.vue?vue&type=style&index=0&id=6b7977d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7977d6",
  null
  
)

export default component.exports